export default __webpack_public_path__ + "static/newsletter-img@2x-7e1c5799cc21d910da35f67abdb8de8d.png";